import helpers from '@/mixins/helpers';

import jobChange from './jobChange/index.vue';

import Api from '@/utils/api';

export default {
  mixins: [
    helpers.general,
  ],
  props: {
    job: {
      type: Object,
      default: () => {},
    },
    editData: {
      type: Object,
      default: () => {},
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    jobChange,
  },
  data () {
    return {
      dropdown: false,
    };
  },
  computed: {
    jobChange () {
      if (!this.job.JobState) {
        return false;
      }
      return this.checkPermissions('job', 'job-change');
    },
  },
  methods: {
    /**
         * Open inputs for edit jobs
         */
    openEditJob () {
      this.dropdown = false;
      this.$emit('changeEdit');
      this.$nextTick(() => this.$refs.name.focus());
    },

    /**
         * Method for close job
         */
    closeJob () {
      Api.jobs
        .closeJob(this.job.ID)
        .then((response) => {
          if (response.data.Status) {
            this.$root.$emit('notification', {
              message: 'The job’ve been closed',
              type: 'info',
              show: true,
            });

            this.$emit('close');
          } else {
            this.$root.$emit('notification', {
              message: 'The job’ve been closed',
              type: 'info',
              show: true,
            });
          }
        });
    },
  },
};
